import {
  Accessibility,
  AccountBox,
  Email,
  ExpandMore as ExpandMoreIcon,
  Logout,
  PowerSettingsNew,
  SupervisorAccount,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Collapse,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { Employee } from "../../../app/backendTypes";
import { tsToDate } from "../../../app/utils";
import ExpandMore from "../ExpandMore";

function EmployeeFields(props: { employee: Employee }) {
  const { employee } = props;


  const status = employee.status.toString();
  const statusDisplay =
    status.charAt(0).toUpperCase() + status.slice(1);

  const leavingDate = employee.leavingDate
    ? tsToDate(employee.leavingDate)
    : null;
  const leavingDateDisplay =
    leavingDate !== null
      ? `${leavingDate.toDateString()} at ${leavingDate.toLocaleTimeString()}`
      : "None";

  const now = new Date();
  const isLeavingDateExpired = leavingDate !== null ? leavingDate < now : false;
  // const isExternal =
  //   employee.employeeType === EmployeeType.EXTERNAL_CONSULTANT;
  // const isActive = employee.status !== EmployeeStatus.PERMANENT && employee.leavingDate!==null;
  
  // const isNonVismaInfra =
  //   employee.DescriptionType === LoginReason.NonVismaInfrastructure;

  const theme = useTheme();

  const [expanded, setExpaned] = useState(false);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Typography color="text.secondary">Fields</Typography>
        <ExpandMore expand={expanded} onClick={() => setExpaned(!expanded)}>
          <ExpandMoreIcon />
        </ExpandMore>
      </Box>
      <Collapse in={expanded} timeout="auto">
        <List dense>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <AccountBox />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Username"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={employee.username}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <Email />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Email"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={employee.email}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <SupervisorAccount />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Manager Email"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={employee.managerEmail}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <Accessibility />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Employee Type"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={employee.employeeType}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar
                
              >
                <PowerSettingsNew />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Status"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={statusDisplay}
            />
          </ListItem>
          <ListItem>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor:
                    leavingDate !== null
                      ? isLeavingDateExpired
                        ? theme.palette.error.main
                        : theme.palette.warning.main
                      : "default",
                }}
              >
                <Logout />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Leaving Date"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={leavingDateDisplay}
            />
          </ListItem>
          {/* <ListItem>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: isNonVismaInfra
                    ? theme.palette.error.main
                    : "default",
                }}
              >
                <Description />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Description Type"
              primaryTypographyProps={{ fontWeight: "bold" }}
              secondary={employee.DescriptionType}
            />
          </ListItem> */}
        </List>
      </Collapse>
    </>
  );
}

export default EmployeeFields;
